import { DocumentTableColumns } from '../modules/documents/components/DocumentTableColumns';
import { Category } from '../interfaces/documents';
import { MenuItemType } from 'antd/es/menu/interface';
import { useFetchDocumentsPage } from './useFetchDocumentsPage';
import { useModeDocumentsPage } from './useModeDocumentsPage';
import { ModeDocumentsPageType } from '../types';
import { useDocumentsNavigateTo } from './useDocumentsNavigateTo';
import { isCategory } from '../utilities/constants';

export const useColumnsBaseTableDocuments = (modeDocument: ModeDocumentsPageType, draggable: boolean, filterActions?: (actions: MenuItemType[]) => MenuItemType[]) => {
    const { fetchData } = useFetchDocumentsPage(modeDocument);
    const { navigateTo } = useDocumentsNavigateTo(modeDocument);
    const { isDocuments, isDeleted } = useModeDocumentsPage(modeDocument);

    const handleCategory = (category: Category) => {
        if (!navigateTo) return;
        navigateTo(category.id);
    };

    const columns = DocumentTableColumns({ fetchData, navigateTo, isDocuments, isDeleted, draggable, filterActions });
    // set up click events for each column - we do not use onRow as it also includes the checkbox for a row
    columns?.forEach((column) => {
        column.onCell = (row) => {
            return {
                onClick: () => {
                    if (isCategory(row) && !isDeleted) {
                        handleCategory(row as Category);
                    }
                },
            };
        };
    });

    return columns;
};
